export const START_COURSE = 'RUN_TYPE__START_COURSE';

export const PREV_SLIDE = 'RUN_TYPE__PREV_SLIDE';
export const UPDATE_TIMER = 'RUN_TYPE__UPDATE_TIMER';
export const UPDATE_SLIDE_TIMER = 'RUN_TYPE__UPDATE_SLIDE_TIMER';

export const RESET_RUN = 'RUN_TYPE__RESET_RUN';
export const CALCULATE_TIME = 'RUN_TYPE__CALCULATE_TIME';
